import { Controlled_PropertyBooleanInput } from './Controlled_PropertyBooleanInput';
import { Controlled_PropertyBooleanSwitchInput } from './Controlled_PropertyBooleanSwitchInput';
import { Controlled_PropertyEnumInput } from './Controlled_PropertyEnumInput';
import { Controlled_PropertyMultilineStringInput } from './Controlled_PropertyMultilineStringInput';
import { Controlled_PropertyNameInput } from './Controlled_PropertyNameInput';
import { Controlled_PropertyNumberInput } from './Controlled_PropertyNumberInput';
import { Controlled_PropertySelectInput } from './Controlled_PropertySelectInput';
import { Controlled_PropertyStringInput } from './Controlled_PropertyStringInput';

export const ControlledPropertyInputs = {
    Enum: Controlled_PropertyEnumInput,
    Select: Controlled_PropertySelectInput,
    Number: Controlled_PropertyNumberInput,
    String: Controlled_PropertyStringInput,
    Name: Controlled_PropertyNameInput,
    MultilineString: Controlled_PropertyMultilineStringInput,
    Boolean: Controlled_PropertyBooleanInput,
    BooleanSwitch: Controlled_PropertyBooleanSwitchInput,
};